export default __webpack_public_path__ + "static/media/you-get-A.e102ace2.webp";